var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { BreakpointConsumer } from "../../../utils/Breakpoints";
import * as I18n from "../../../utils/translations/I18n";
export var DragNDropArea = function (props) { return (React.createElement("div", __assign({}, props.wrapper({ className: "dropzone scl-o-dragndrop-area" })),
    React.createElement("input", __assign({}, props.input(), { className: "scl-o-dragndrop-area__input" })),
    React.createElement(BreakpointConsumer, null, function (value) {
        if (!value.breakpointAtSM) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "scl-o-dragndrop-area__title" }, I18n.getText("mary.07-organisms.dragndroparea.title--touch", "Click & Select")),
                React.createElement("div", { className: "scl-o-dragndrop-area__description" }, I18n.getText("mary.07-organisms.dragndroparea.description--touch", "And upload your files"))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "scl-o-dragndrop-area__title" }, I18n.getText("mary.07-organisms.dragndroparea.title", "Drag & Drop")),
                React.createElement("div", { className: "scl-o-dragndrop-area__description" }, I18n.getText("mary.07-organisms.dragndroparea.description", "Or click to select files"))));
        }
    }))); };
